import { useMutation } from 'react-query';

import { deleteUserGroup as mutationFn } from 'api/endPoints/deleteUserGroup';

export const useMutationDeleteUserGroup = () => {
    return useMutation<
        unknown,
        QueryError,
        {
            group_name: string;
            customer_id: number;
        }
    >((params) => mutationFn(params));
};
